<template>
  <div class="message_wrapper">
    <div class="title_wrapper">
      <img src="../../../assets/images/title/kxjjy.png" alt="">
      <!-- <p class="title_transition">Testimonials</p> -->
    </div>
    <div class="content_wrapper">
      <div class="single_content">
        <img src="../../../../static/xd/lb.png" alt="">
        <div class="message_content">
          What is science? It reflects the core values of truth, goodness and beauty. Truth refers to the exploration of the unknown. Goodness means we as scientists are always sustaining and fostering a culture of scientific integrity, teamwork and critical thinking. The process of scientific discoveries is regarded as great beauty and we enjoy the happiness and curiosity along the way.
          <div class="signature_title">
            —— Lu Bai, Professor at Tsinghua University
          </div>
        </div>
      </div>
      <div class="single_content">
        <div class="message_content">
          What should social elites study? The answer is science. It’s the nature of our modern age. It gives us a higher level of knowledge and creates the logic to decode our society.
          <div class="signature_title">
            —— Wu Guosheng, Professor at Tsinghua University
          </div>
        </div>
        <img src="../../../../static/xd/wgs.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
      }
    },
    created () {},
    methods: {}
  }
</script>

<style scoped lang="less">
  .message_wrapper {
    width: 80%;
    max-width: 1200px;
    margin: 0 auto;
    .title_wrapper {
      padding: 50px 0 30px;
      width: 100%;
      font-size: 16px;
      color: #666;
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      img {
        width: 100%;
        margin-bottom: 20px;
        
      }
    // remove
    .title_transition {
      font-size: 24px;
      font-weight: 700;
      color: #000;
    }
    }
    .content_wrapper {
      .single_content {
        width: 100%;
        margin-bottom: 20px;
        display: flex;
        align-items: center;
        text-align: left;
        margin-bottom: 30px;
        .message_content {
          line-height: 1.8;
          .signature_title {
            width: 100%;
            text-align: end;
            margin-top: 10px;
          }
        }
        img {
          width: 150px;
          height: 150px;
          border-radius: 50%;
        }
        img:nth-child(2n -1) {
          margin-right: 30px;
        }
        img:nth-child(2n) {
          margin-left: 30px;
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/pages/home/message/message.vue